import React from 'react';
import TopNav from '../navigation/TopNav';
import SmsPrompt from '../SmsPrompt';
import EarlySupporterBanner from '../EarlySupporterBanner';
import './Layout.css';

const Layout = ({ children }) => {
  return (
    <div className="layout-container">
      <EarlySupporterBanner />
      <TopNav />
      <main className="layout-main">
        {children}
      </main>
      <SmsPrompt />
    </div>
  );
};

export default Layout; 